import { ITableProps } from '@kurtosys/ksys-app-components/dist/components/base/Table/models';
import { IDisclaimersProps } from '@kurtosys/ksys-app-components/dist/components/overview/Disclaimers/models';
import { IBreakpointProps } from '@kurtosys/ksys-app-components/dist/models/IBreakpointProps';
import { computed, action, observable } from 'mobx';
import { StoreBase } from '../../../common/StoreBase';
import { ITableConfiguration } from '../models';

export class TableStore extends StoreBase {
	static componentKey: 'table' = 'table';

	pivotKey: string = 'name';
	@observable seriesProps: any[] = [];

	@computed
	get configuration(): ITableConfiguration | undefined {
		if (this.storeContext && this.storeContext.appStore) {
			return this.storeContext.appStore.getComponentConfiguration(TableStore.componentKey);
		}
	}

	@action
	async initialize(): Promise<void> {

	}

	@computed
	get breakpoints(): IBreakpointProps<ITableProps>[] {
		const { appStore, barChartStore } = this.storeContext;

		if (!appStore.breakpoints) {
			return [];
		}

		return appStore.breakpoints.map((breakpoint) => {
			this.seriesProps = barChartStore.getSeriesProps();
			const breakpointConfiguration: ITableConfiguration = {
				...this.configuration,
				...(breakpoint.props && breakpoint.props.tableConfig),
			};

			const { tableProps, formatter: format, pivotData = false, nameFieldLabel = 'Name' } = breakpointConfiguration;
			const rows = this.getRows(pivotData);
			let columns: any[] = (tableProps && tableProps.columns) || [];
			if (rows.length > 0 && columns.length === 0) {
				columns = Object.keys(rows[0]).map((key) => {
					return {
						key,
						format,
						id: key,
						header: key === 'name' ? nameFieldLabel : this.getSeriesName(key),
					};
				});
			}
			return {
				modifier: breakpoint.modifier,
				size: breakpoint.size,
				props: {
					...tableProps,
					columns,
					rows,
					disclaimersProps: this.disclaimersProps,
				},
			};
		});
	}

	@computed
	get disclaimersProps(): IDisclaimersProps | undefined {
		const { barChartStore } = this.storeContext;
		const chartProps = barChartStore.chartProps;
		if (chartProps) {
			return {
				...chartProps.disclaimersProps,
				disclaimers: barChartStore.disclaimers,
			};
		}
	}

	getRows(pivotData: boolean): any[] {
		const { data = [] } = this.storeContext.barChartStore;
		if (!pivotData) {
			return data;
		}
		const result: { [key: string]: any } = {};
		data.forEach((dataRow) => {
			const pivotKeyValue = dataRow[this.pivotKey];
			Object.keys(dataRow).forEach((dataKey: string) => {
				if (dataKey !== this.pivotKey) {
					if (!result[dataKey]) {
						result[dataKey] = {};
					}
					result[dataKey][pivotKeyValue] = dataRow[dataKey];
				}
			});
		});
		return Object.keys(result).map((key) => {
			return {
				[this.pivotKey]: this.getSeriesName(key),
				...result[key],
			};
		});
	}

	getSeriesName(key: string) {
		const series = this.seriesProps.find(s => s.dataKey === key);
		if (series) {
			return series.name;
		}
		return key;
	}

	@computed
	get hasData(): boolean {
		return this.storeContext.barChartStore && this.storeContext.barChartStore.hasData;
	}
}